// react-routers components
import { Link } from "react-router-dom";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import AsyncSelect from "react-select/async";

import { useState } from "react";
import TypesApi from "../../../../../Classes/API/UsersApi";

import SearchTherapistTypes from "../../../../../Classes/Models/Requests/Administration/Therapists/SearchTherapistTypes";
import AddTherapistToTypeReq from "../../../../../Classes/Models/Requests/AddManyToManyReq";

function TherapistInfoCard({ User, GetUserData, shadow }) {
  const Therapist = User.getTherapist;

  const [SelectedTypeId, setTypeId] = useState(
    Therapist.getTherapistType && Therapist.getTherapistType.id
  );

  const [TypesSearch, setTypesSearch] = useState("");

  const NoTypeOption = { value: "", label: "*Not Assigned!!!" };

  const getTypeDefaultOption = () => {
    if (Therapist.getTherapistType) {
      return { value: Therapist.getTherapistType.id, label: Therapist.getTherapistType.typeName };
    } else {
      return NoTypeOption;
    }
  };
  const GetTypes = async () => {
    let req = new SearchTherapistTypes();
    req.typeName = TypesSearch;
    var res = await TypesApi.SearchTherapistTypes(req);
    console.log(res);
    let optionsArr = [];
    res.data.list.forEach((item) => {
      optionsArr.push({ value: item.id, label: item.typeName });
    });
    // setTherapistTypes(res.data.list)

    return optionsArr;
  };

  const SaveType = async () => {
    let req = new AddTherapistToTypeReq();
    req.Id1 = Therapist.id;
    req.Id2 = SelectedTypeId;
    var res = await TypesApi.AssignTherapistToType(req);

    if (res.status == "Success") {
      GetUserData(User.id);
    }
  };

  return (
    <Card sx={{ height: "100%", boxShadow: !shadow && "none" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="left" pt={2} px={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Therapist Info
        </MDTypography>
        {/* <MDTypography   variant="body2" color="secondary">
          <Tooltip   placement="top">
            <Icon>edit</Icon>
          </Tooltip>
        </MDTypography> */}
      </MDBox>
      <MDBox p={2}>
        <MDBox>
          <MDBox display="flex" py={1} pr={2}>
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Therapist Id: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Therapist.id}
            </MDTypography>
          </MDBox>

          {/* <MDBox
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            alignItems="center"
            py={1}
            pr={2}
            gap={2}
          >
            <MDTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
              sx={{ width: { xs: "100%", sm: "auto" }, mb: { xs: 1, sm: 0 } }}
            >
              Therapist Type:
            </MDTypography>
            <MDTypography
              variant="button"
              fontWeight="regular"
              color="text"
              sx={{ width: { xs: "100%", sm: "auto" }, mb: { xs: 1, sm: 0 } }}
            >
              <AsyncSelect
                isClearable={true}
                defaultValue={getTypeDefaultOption}
                loadOptions={GetTypes}
                onInputChange={setTypesSearch}
                onChange={(e) => setTypeId(e ? e.value : "")}
                styles={{ container: (provided) => ({ ...provided, width: "150px" }) }}
              />
            </MDTypography>
            <button
              onClick={() => SaveType()}
              className="btn btn-outline-dark"
              style={{
                width: "100%",
                height: "40px",
                maxWidth: "150px",
                marginTop: { xs: "10px", sm: "0" },
                padding: "10px 20px",
                fontSize: "16px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              Save
            </button>
          </MDBox> */}

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              HourlyRate: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;
              {Therapist.getTherapistType ? Therapist.getTherapistType.standardHourlyRate : "NA"}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Hours Worked: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Therapist.hoursWorked}
            </MDTypography>
          </MDBox>
          <MDBox display="flex" py={1} pr={2}>
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Hours Paid: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Therapist.hoursPaid}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

// Setting default props for the ProfileInfoCard
TherapistInfoCard.defaultProps = {
  shadow: true,
};

// Typechecking props for the ProfileInfoCard
TherapistInfoCard.propTypes = {
  shadow: PropTypes.bool,
};

export default TherapistInfoCard;
